/** @format */

import { HmfButtonComponent, HmfCheckboxComponent } from '@dsg-tech/homefield-angular';
import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconAlertInfoFilled,
	homefieldIconOrderCartStandard,
	homefieldIconStarFilled,
	homefieldIconStarOutlined
} from '@dsg-tech/homefield-angular-icons';

import { CommonModule } from '@angular/common';
import { HomefieldAvailabilityModule } from './product-availability';
import { HomefieldButtonModule } from '../button';
import { HomefieldColorSwatchModule } from '../color-swatch';
import { HomefieldPriceModule } from '../price';
import { HomefieldProductBadgeModule } from '../product-badge';
import { HomefieldProductCardColorSwatchesModule } from './product-card-color-swatches';
import { HomefieldProductCardComponent } from './product-card.component';
import { HomefieldProductCardImageSwatchesComponent } from './product-card-image-swatches';
import { HomefieldProductImageModule } from '../product-image';
import { HomefieldProductTitleModule } from './product-title';
import { HomefieldPromotionModule } from './promotion';
import { HomefieldSkeletonProductCardComponent } from './skeleton-product-card/skeleton-product-card.component';
import { HomefieldStarRatingsComponent } from '../star-ratings/star-ratings.component';
import { HomefieldStrikethroughPriceModule } from '../strikethrough-price';
import { HomefieldTextLinkModule } from '../text-link';
import { NgModule } from '@angular/core';

@NgModule({
	declarations: [HomefieldProductCardComponent, HomefieldSkeletonProductCardComponent],
	exports: [HomefieldProductCardComponent, HomefieldSkeletonProductCardComponent],
	imports: [
		CommonModule,
		HmfButtonComponent,
		HmfCheckboxComponent,
		HomefieldAvailabilityModule,
		HomefieldButtonModule,
		HomefieldColorSwatchModule,
		HomefieldIconLibraryModule,
		HomefieldPriceModule,
		HomefieldProductBadgeModule,
		HomefieldProductCardColorSwatchesModule,
		HomefieldProductCardImageSwatchesComponent,
		HomefieldProductImageModule,
		HomefieldProductTitleModule,
		HomefieldPromotionModule,
		HomefieldStarRatingsComponent,
		HomefieldStrikethroughPriceModule,
		HomefieldTextLinkModule
	]
})
export class HomefieldProductCardModule {
	constructor(homefieldIconsLibraryService: HomefieldIconsLibraryService) {
		homefieldIconsLibraryService.registerIcons([
			homefieldIconOrderCartStandard,
			homefieldIconStarOutlined,
			homefieldIconStarFilled,
			homefieldIconAlertInfoFilled
		]);
	}
}
